import { MessageCircle, X } from "lucide-react";
import { useState } from "react";

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Simple WhatsApp link - just phone number, no text parameter
  const whatsappLink = "https://wa.me/919464645491";

  return (
    <>
      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {isOpen && (
          <div className="mb-4 bg-white rounded-2xl shadow-2xl p-6 w-80 animate-slideUp">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <MessageCircle className="text-white" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Chat with us!</h4>
                  <p className="text-sm text-gray-600">We reply instantly</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={20} />
              </button>
            </div>
            
            <p className="text-sm text-gray-600 mb-4">
              Hi! 👋 Need help with e-commerce onboarding? We're here to assist you!
            </p>
            
            <a
              href="https://wa.me/919464645491"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-green-500 text-white text-center py-3 rounded-full font-semibold hover:bg-green-600 transition mb-2"
            >
              Start Chat on WhatsApp
            </a>

            <a
              href="tel:+919464645491"
              className="block w-full bg-gray-100 text-gray-700 text-center py-3 rounded-full font-semibold hover:bg-gray-200 transition"
            >
              Or Call Directly
            </a>
            
            <p className="text-xs text-gray-500 text-center mt-3">
              Response time: Instant ⚡
            </p>
          </div>
        )}
        
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-2xl shadow-blue-600/25 flex items-center gap-2 transition-all duration-300 transform hover:scale-105 px-5 py-3"
          aria-label="Chat on WhatsApp"
          data-testid="whatsapp-widget-button"
        >
          {isOpen ? (
            <X size={24} />
          ) : (
            <>
              <MessageCircle size={22} />
              <span className="font-bold text-sm hidden sm:inline">Chat with Expert - Free</span>
            </>
          )}
        </button>
      </div>

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
          }
          50% {
            box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
          }
        }
        .pulse-animation {
          animation: pulse 2s infinite;
        }
      `}</style>
    </>
  );
};

export default WhatsAppWidget;